<template>
    <div class="two-cols-box">
        <terminal-types :items="terminalTypes" title="LX Terminal Types" :loadMoreItems="terminalTypesLoadMore" />
        <terminal-types :items="subscriptions" title="LX Subscriptions" :loadMoreItems="subscriptionsLoadMore"  type="subscription"/>
    </div>
</template>

<script>

import TerminalTypes from "./TerminalTypes";
import {mapActions, mapState} from "vuex"

export default {
    name: 'lx-settings',

    components: {TerminalTypes},

    computed: {
        ...mapState('settings', [
            'terminalTypes',
            'subscriptions',
            'terminalTypesLoadMore',
            'subscriptionsLoadMore'
        ])
    },
    mounted() {
        //this.getLXSettings();
    },

    methods: {
        ...mapActions('settings',[
            'getLXSettings'
        ])
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
